import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap, switchMapTo, take } from "rxjs/operators";
import { selectNextThemedEventStartInterval } from "../../../selectors/selectEventInfo";
import { utilTick } from "../../../utils/utilTick";
import { actionEventInfoRequest, TypeActionEventInfo } from "../../info/event/actionEventInfo";
import { actionThemedEventLoadBuilding } from "../actionThemedEvent";
export var epicThemedEventTimeStart = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionEventInfo.Received), switchMap(function () {
        var state = state$.value;
        return utilTick.getInterval$(selectNextThemedEventStartInterval(state));
    }), take(1), switchMapTo(from([actionEventInfoRequest(), actionThemedEventLoadBuilding()])));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/epics/epicThemedEventTimeStart.ts
// module id = 2428
// module chunks = 3